module.exports = __webpack_public_path__ + "static/media/beneficiary.b99266e8.mp3";